import React, { useState, useEffect, useRef } from "react";
import Form from "../../components/Form/Form";
import { useFormConfig } from "./QuestionsFieldsConfig";
import { addQuestion, updateQuestion } from "../../services/QuestionService";
import { useLocation } from "react-router-dom";
import { Toast } from "primereact/toast";

function QuestionForm({ onClose, onFormSubmit }) {
  const location = useLocation();
  const { mode, question } = location.state || {};
  const { questionForm } = useFormConfig(question, mode);
  const [formData, setFormData] = useState(questionForm.initialFormData);
  const toastRef = useRef(null);

  useEffect(() => {
    if (mode === "update" && question) {
      setFormData({
        text: question.queTranslations?.text || "",
        totalOptions: question.total_options || 4,
        courseId: question.Course?.id || null,
        moduleId: question.Module?.id || null,
        topicId: question.Topic?.id || null,
        answers: question.answers || []
      });
    }
  }, [mode, question]);

  const handleSubmit = async (questionFormData) => {
  try {
    if (mode === "update" && question) {
      await updateQuestion(question.id, questionFormData);
      toastRef.current?.show({
        severity: "success",
        summary: "Success",
        detail: "Question updated successfully!",
      });
    } else {
      await addQuestion(questionFormData);
      toastRef.current?.show({
        severity: "success",
        summary: "Success",
        detail: "Question added successfully!",
      });
    }
    setTimeout(() => {
      onClose();
      onFormSubmit?.();
    }, 500);
  } catch (error) {
    console.error("Error submitting question:", error);
    toastRef.current?.show({
      severity: "error",
      summary: "Error",
      detail: "Failed to submit question.",
    });
  }
};

  return (
    <>
      <Toast ref={toastRef} />
      <Form
        formTitle={questionForm.formTitle}
        initialFormData={formData}
        fieldConfig={questionForm.fieldConfig}
        onSubmit={handleSubmit}
        onClose={onClose}
        mode={mode}
      />
    </>
  );
}

export default QuestionForm;